import Vue from 'vue'

import '@/styles/index.scss' // global css
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import 'element-ui/lib/theme-chalk/index.css'

import ElementUI from 'element-ui'
import App from './App'
import store from './store'
import router from './router'

import '@/icons' // icon
import '@/permission' // permission control
import { ApiManagerClient } from '@/../grpc/manager_grpc_web_pb'// 引入grpcJs

// 建立grpc连接服务 go/bin/grpcui -port 20001 -plaintext 192.168.0.3:9093
// 测试接口  https://t-otapi.beswell.com:10001
const client_develop = new ApiManagerClient(process.env.VUE_APP_BASE_API)
// 正式接口  https://otapi.beswell.com:10001
// const client_develop = new ApiManagerClient('https://otapi.beswell.com:10001')

// 挂载为全局方法
Vue.prototype.client = client_develop

// 是否使用mockJs
if (process.env.NODE_ENV === 'develo') { // development
  const { mockXHR } = require('../mock')
  mockXHR()
}

// 当前环境名称
// console.log(process.env)

// set ElementUI lang to EN
// Vue.use(ElementUI, { locale })
// 如果想要中文版 element-ui，按如下方式声明
Vue.use(ElementUI)

Vue.config.productionTip = false

const vue = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})

export default vue
